import { render, staticRenderFns } from "./AliPayIcon.vue?vue&type=template&id=82d4c5b6&"
import script from "./AliPayIcon.vue?vue&type=script&lang=js&"
export * from "./AliPayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports